import { FormEvent, useEffect, useState } from "react";
import Navigation from "../../header";
import { Button, Container, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { ShipmentService } from "../../../services/shipmentService";
import { IShipmentReportByVendorRequest, IShipmentReportByVendorRow } from "../../../types/shipment";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { ISelectOption } from "../../../types/list";
import { ICustomerLight } from "../../../types/customer";
import { CustomerService } from "../../../services/customerService";
import { UtilityService } from "../../../services/utilityService";
import Json from "../../json";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Form } from "react-router-dom";
import moment from "moment";
import PermissionGate from "../../permissionGate";
import { useUserContext } from "../../../contexts/userContext";

const MonthlySummaryReportByVendor = () => {
	var userContext = useUserContext();

	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext?.permissions?.canViewReportMonthlySummaryByVendor}>
					<h1 className="report-header">Monthly Summary Report by Vendor</h1>
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=799fbf63-e552-44a9-b481-0858308c403d&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi"></embed>
				</PermissionGate>
			</Container>
		</>
	);
};

export default MonthlySummaryReportByVendor;